import { ContentBlock, EditorState } from 'draft-js'
import { MouseClickEvent } from 'builder/modules/ui'

export enum StyleTypes {
  Bold = 'BOLD',
  Italic = 'ITALIC',
  Underline = 'UNDERLINE',
  Strike = 'STRIKETHROUGH',
  OrderedList = 'ordered-list-item',
  UnorderedList = 'unordered-list-item',
}

export type IncorrectWord = {
  word: string
  suggestions: string[]
}

export type DecoratorCallback = (start: number, end: number) => void

export type Ranges = {
  bad: {
    start: number
    end: number
  }
  good: {
    start: number
    end: number
  }
}

export type SpellCheckStrategy = (contentBlock: ContentBlock, callback: DecoratorCallback) => void

export type SpellCheckStore = {
  getEditorState: (() => EditorState) | undefined
  setEditorState: ((state: EditorState) => void) | undefined
}

export type SpellCheckSuggestion = {
  wordId: string
  word: string
  position: {
    top: number
    left: number
  }
  wordStartIndex: number
  wordEndIndex: number
  blockKey: string
}

export type RichTextEditorInstanceWrapper = {
  focusEditor: () => void
  addPhrase: (item: { phrase: string; isSubphrase?: boolean }, isList: boolean) => void
  replacePhrase: (phrase: string) => void
  getEditorText: () => string
}

export type ToolbarActions = {
  handleClickBlock: (event: MouseClickEvent, type: StyleTypes) => void
  handleClickLink: (event: MouseClickEvent) => void
  handleClickMark: (event: MouseClickEvent, type: StyleTypes) => void
  handleClickSpellCheck: () => void
}

export interface TextAreaProps {
  instanceRef?: React.MutableRefObject<RichTextEditorInstanceWrapper | null>
  containerRef?: React.MutableRefObject<HTMLDivElement | null>
  autoFocus?: boolean
  recommendedLength?: number
  label?: string
  placeholder?: string
  value?: string
  onChange: (html: string) => void
  locale?: string
  height?: number
  labelBadges?: JSX.Element[]
  supportedLocales?: string[]
  boldButtonDisable?: boolean
  italicButtonDisable?: boolean
  linkButtonDisable?: boolean
  disableToolbar?: boolean
  ranges?: Ranges
  recommendedRangeLabel?: string
  isAnimating?: boolean
  onAnimationEnd?: () => void
  onTextLengthChange?: (length: number) => void
  onFocus?: () => void
  additionalToolbarActions?: JSX.Element | null
}
